"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.importOpeningBalancesRequestSchema = exports.journalWorkflowActionRequestSchema = exports.reverseJournalEntryRequestSchema = exports.rejectJournalEntryRequestSchema = exports.createJournalEntryRequestSchema = void 0;
/**
 * Request contracts for the Journal Voucher workflow (Stage 13,
 * Milestone 1) — `JournalApplicationService`
 * (`backend/src/modules/financial/application/journal.application-service.ts`).
 */
const zod_1 = require("zod");
const financial_common_request_1 = require("./financial-common.request");
const journalLineSchema = zod_1.z.object({
    accountId: zod_1.z.string().uuid(),
    drOrCr: zod_1.z.enum(['DEBIT', 'CREDIT']),
    amount: zod_1.z.number().int().positive(),
    costCenterId: zod_1.z.string().uuid().optional(),
    profitCenterId: zod_1.z.string().uuid().optional(),
    narration: zod_1.z.string().optional(),
});
exports.createJournalEntryRequestSchema = zod_1.z.object({
    entryDate: zod_1.z.coerce.date(),
    entryType: zod_1.z.enum([
        'AUTO',
        'MANUAL',
        'CLOSING',
        'REVERSAL',
        'CONTRA',
        'RECEIPT',
        'PAYMENT',
        'DEBIT_NOTE',
        'CREDIT_NOTE',
    ]),
    narration: zod_1.z.string().optional(),
    branchId: zod_1.z.string().uuid().optional(),
    hospitalId: zod_1.z.string().uuid().optional(),
    externalReference: zod_1.z.string().max(100).optional(),
    projectTag: zod_1.z.string().max(100).optional(),
    lines: zod_1.z.array(journalLineSchema).min(2),
    ...financial_common_request_1.financialWorkflowExtrasShape,
});
exports.rejectJournalEntryRequestSchema = zod_1.z.object({
    reason: zod_1.z.string().min(1),
    ...financial_common_request_1.financialWorkflowExtrasShape,
});
exports.reverseJournalEntryRequestSchema = zod_1.z.object({
    reason: zod_1.z.string().optional(),
    ...financial_common_request_1.financialWorkflowExtrasShape,
});
exports.journalWorkflowActionRequestSchema = zod_1.z.object({
    ...financial_common_request_1.financialWorkflowExtrasShape,
});
const openingBalanceLineSchema = zod_1.z.object({
    accountId: zod_1.z.string().uuid(),
    drOrCr: zod_1.z.enum(['DEBIT', 'CREDIT']),
    amount: zod_1.z.number().int().positive(),
});
exports.importOpeningBalancesRequestSchema = zod_1.z.object({
    financialYearId: zod_1.z.string().uuid(),
    entryDate: zod_1.z.coerce.date(),
    lines: zod_1.z.array(openingBalanceLineSchema).min(2),
    ...financial_common_request_1.financialWorkflowExtrasShape,
});
//# sourceMappingURL=financial-journal.request.js.map